/**
 * vue-snotify v2.0.3
 * (c) 2017 artemsky <mr.artemsky@gmail.com>
 * @license MIT
 */
import Vue from 'vue';

var SnotifyIcon = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('svg', { staticStyle: { "enable-background": "new 0 0 48 48" }, attrs: { "xmlns": "http://www.w3.org/2000/svg", "version": "1.1", "x": "0px", "y": "0px", "viewBox": "0 0 512 512", "xml:space": "preserve", "width": "48px", "height": "48px" } }, [_vm.type === 'warning' ? _c('g', { staticClass: "snotify-icon__warning" }, [_c('path', { attrs: { "d": "M256,512c141.15,0,256-114.84,256-256S397.15,0,256,0,0,114.84,0,256,114.85,512,256,512Zm0-480.49c123.79,0,224.49,100.71,224.49,224.49S379.79,480.49,256,480.49,31.51,379.79,31.51,256,132.21,31.51,256,31.51Z" } }), _c('circle', { attrs: { "cx": "260.08", "cy": "343.87", "r": "26.35" } }), _c('path', { attrs: { "d": "M254.68,278.39a15.76,15.76,0,0,0,15.75-15.75V128.72a15.75,15.75,0,1,0-31.51,0V262.63A15.76,15.76,0,0,0,254.68,278.39Z" } })]) : _vm.type === 'success' ? _c('g', { staticClass: "snotify-icon__success" }, [_c('path', { attrs: { "d": "M256,0C114.85,0,0,114.84,0,256S114.85,512,256,512,512,397.16,512,256,397.15,0,256,0Zm0,492.31c-130.29,0-236.31-106-236.31-236.31S125.71,19.69,256,19.69,492.31,125.71,492.31,256,386.29,492.31,256,492.31Z" } }), _c('path', { staticClass: "cls-1", attrs: { "d": "M376.64,151,225.31,321.24l-91.17-72.93a9.85,9.85,0,0,0-12.3,15.38l98.46,78.77a9.86,9.86,0,0,0,13.52-1.15L391.36,164.08A9.85,9.85,0,0,0,376.64,151Z" } })]) : _vm.type === 'info' ? _c('g', { staticClass: "snotify-icon__info" }, [_c('path', { attrs: { "d": "M256,0C114.84,0,0,114.84,0,256S114.84,512,256,512,512,397.16,512,256,397.15,0,256,0Zm0,478.43C133.35,478.43,33.57,378.64,33.57,256S133.35,33.58,256,33.58,478.42,133.36,478.42,256,378.64,478.43,256,478.43Z" } }), _c('path', { attrs: { "d": "M251.26,161.24a22.39,22.39,0,1,0-22.38-22.39A22.39,22.39,0,0,0,251.26,161.24Z" } }), _c('path', { attrs: { "d": "M286.84,357.87h-14v-160A16.79,16.79,0,0,0,256,181.05H225.17a16.79,16.79,0,0,0,0,33.58h14.05V357.87H225.17a16.79,16.79,0,0,0,0,33.57h61.67a16.79,16.79,0,1,0,0-33.57Z" } })]) : _vm.type === 'error' ? _c('g', { staticClass: "snotify-icon__error" }, [_c('path', { attrs: { "d": "M437,75A256,256,0,1,0,75,437,256,256,0,1,0,437,75ZM416.43,416.43a226.82,226.82,0,0,1-320.86,0C7.11,328,7.11,184,95.57,95.57a226.82,226.82,0,0,1,320.86,0C504.89,184,504.89,328,416.43,416.43Z" } }), _c('path', { attrs: { "d": "M368.81,143.19a14.5,14.5,0,0,0-20.58,0L256,235.42l-92.23-92.23a14.55,14.55,0,0,0-20.58,20.58L235.42,256l-92.23,92.23a14.6,14.6,0,0,0,10.24,24.89,14.19,14.19,0,0,0,10.24-4.31l92.23-92.23,92.23,92.23a14.64,14.64,0,0,0,10.24,4.31,14,14,0,0,0,10.24-4.31,14.5,14.5,0,0,0,0-20.58l-92-92.23,92.23-92.23A14.5,14.5,0,0,0,368.81,143.19Z" } })]) : _vm.type === 'async' ? _c('g', { staticClass: "snotify-icon__async" }, [_c('path', { attrs: { "d": "M256,0a32,32,0,0,0-32,32V96a32,32,0,0,0,64,0V32A32,32,0,0,0,256,0Zm0,384a32,32,0,0,0-32,32v64a32,32,0,0,0,64,0V416A32,32,0,0,0,256,384ZM391.74,165.5,437,120.22A32,32,0,0,0,391.74,75L346.5,120.22a32,32,0,0,0,45.25,45.28Zm-271.52,181L75,391.74A32,32,0,0,0,120.22,437l45.25-45.25a32,32,0,0,0-45.25-45.25Zm0-271.52A32,32,0,1,0,75,120.22l45.25,45.28a32,32,0,1,0,45.25-45.28ZM391.74,346.5a32,32,0,0,0-45.25,45.25L391.74,437A32,32,0,0,0,437,391.74ZM480,224H416a32,32,0,0,0,0,64h64a32,32,0,0,0,0-64ZM128,256a32,32,0,0,0-32-32H32a32,32,0,0,0,0,64H96A32,32,0,0,0,128,256Z" } })]) : _vm._e()]);
  }, staticRenderFns: [],
  props: ['type']
};

var SnotifyPrompt = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('span', { staticClass: "snotifyToast__input", class: { 'snotifyToast__input--filled': _vm.isPromptFocused } }, [_c('input', { staticClass: "snotifyToast__input__field", attrs: { "type": "text", "id": _vm.id }, on: { "input": _vm.valueChanged, "focus": function focus($event) {
          _vm.isPromptFocused = true;
        }, "blur": function blur($event) {
          _vm.isPromptFocused = !!_vm.length;
        } } }), _c('label', { staticClass: "snotifyToast__input__label", attrs: { "for": _vm.id } }, [_c('span', { staticClass: "snotifyToast__input__labelContent" }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.placeholder)))])])]);
  }, staticRenderFns: [],
  props: ['placeholder'],
  data: function data() {
    return {
      id: 545,
      isPromptFocused: false,
      length: 0
    };
  },

  methods: {
    valueChanged: function valueChanged(e) {
      var value = e.target.value.trim();
      this.length = value.length;
      this.$emit('valueChanged', value);
    }
  }
};

var SnotifyButton = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "snotifyToast__buttons" }, _vm._l(_vm.buttons, function (button) {
      return _c('button', { class: { 'snotifyToast__buttons--bold': button.bold }, attrs: { "type": "button" }, on: { "click": function click($event) {
            button.action && button.action(_vm.id, _vm.value);
          } } }, [_vm._v(_vm._s(button.text))]);
    }));
  }, staticRenderFns: [],
  props: ['buttons', 'value', 'id']
};

/**
 * Toast position
 */
var SnotifyPosition = {
  leftTop: 'leftTop',
  leftCenter: 'leftCenter',
  leftBottom: 'leftBottom',

  rightTop: 'rightTop',
  rightCenter: 'rightCenter',
  rightBottom: 'rightBottom',

  centerTop: 'centerTop',
  centerCenter: 'centerCenter',
  centerBottom: 'centerBottom'
};

/**
 * Toast callback types
 */
var SnotifyAction = {
  mounted: 'mounted',
  destroyed: 'destroyed',
  beforeDestroy: 'beforeDestroy',
  onInput: 'onInput',
  onClick: 'onClick',
  onHoverEnter: 'onHoverEnter',
  onHoverLeave: 'onHoverLeave',
  beforeShow: 'beforeShow',
  shown: 'shown',
  beforeHide: 'beforeHide',
  hidden: 'hidden'
};

/**
 * Toast type,
 */
var SnotifyType = {
  SIMPLE: 'simple',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  ASYNC: 'async',
  CONFIRM: 'confirm',
  PROMPT: 'prompt'
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};







var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/**
 * Simple is object check.
 * @param item {Object}
 * @returns {boolean}
 */
function isObject(item) {
  return item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && !Array.isArray(item) && item !== null;
}

/**
 * Deep merge objects.
 * @param sources
 * @returns {Object}
 */
function mergeDeep() {
  var target = {};

  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }

  if (!sources.length) {
    return target;
  }

  while (sources.length > 0) {
    var source = sources.shift();
    if (isObject(source)) {
      for (var key in source) {
        if (isObject(source[key])) {
          target[key] = mergeDeep(target[key], source[key]);
        } else {
          Object.assign(target, defineProperty({}, key, source[key]));
        }
      }
    }
  }
  return target;
}

/**
 * Generates random id
 * @return {number}
 */
function generateRandomId() {
  return Math.floor(Math.random() * (Date.now() - 1)) + 1;
}

/**
 * Split toasts toasts into different objects
 * @param {SnotifyToast[]} toasts
 * @returns {SnotifyNotifications}
 */
function sortNotificationsByPositions(toasts) {
  var result = {};

  for (var property in SnotifyPosition) {
    if (SnotifyPosition.hasOwnProperty(property)) {
      result[SnotifyPosition[property]] = [];
    }
  }

  toasts.forEach(function (toast) {
    result[toast.config.position].push(toast);
  });

  return result;
}

/**
 * Generate default animation objects
 * @param defaultAnimationTime {number}
 * @returns {{}}
 */
function generateAnimationDefaults(defaultAnimationTime) {
  var _ref;

  return _ref = {}, defineProperty(_ref, SnotifyPosition.leftTop, { enter: 'fadeInLeft', exit: 'fadeOutLeft', time: defaultAnimationTime }), defineProperty(_ref, SnotifyPosition.leftCenter, { enter: 'fadeInLeft', exit: 'fadeOutLeft', time: defaultAnimationTime }), defineProperty(_ref, SnotifyPosition.leftBottom, { enter: 'fadeInLeft', exit: 'fadeOutLeft', time: defaultAnimationTime }), defineProperty(_ref, SnotifyPosition.rightTop, { enter: 'fadeInRight', exit: 'fadeOutRight', time: defaultAnimationTime }), defineProperty(_ref, SnotifyPosition.rightCenter, { enter: 'fadeInRight', exit: 'fadeOutRight', time: defaultAnimationTime }), defineProperty(_ref, SnotifyPosition.rightBottom, { enter: 'fadeInRight', exit: 'fadeOutRight', time: defaultAnimationTime }), defineProperty(_ref, SnotifyPosition.centerTop, { enter: 'fadeInDown', exit: 'fadeOutUp', time: defaultAnimationTime }), defineProperty(_ref, SnotifyPosition.centerCenter, { enter: 'fadeIn', exit: 'fadeOut', time: defaultAnimationTime }), defineProperty(_ref, SnotifyPosition.centerBottom, { enter: 'fadeInUp', exit: 'fadeOutDown', time: defaultAnimationTime }), _ref;
}

/**
 * Toast configuration object
 * @typedef {Object} SnotifyConfig
 * @property {number} [timeout] Toast timeout in milliseconds. Disable timeout = 0
 * @property {boolean} [showProgressBar] Enable/Disable progress bar. Disabled if timeout is 0
 * @property {SnotifyType} [type] Type of toast, affects toast style.
 * @property {boolean} [closeOnClick] Should toast close on click?
 * @property {boolean} [pauseOnHover] Should timeout pause on hover?
 * @property {SnotifyButton[]} [buttons] Buttons config.
 * @property {string} [placeholder] Placeholder for Prompt toast
 * @property {number} [titleMaxLength] Toast title maximum length
 * @property {number} [bodyMaxLength] Toast body maximum length
 * @property {number} [titleMaxLength] Toast title maximum length
 * @property {number} [icon] Activate custom icon. You should provide full tag `<img src="assets/custom-icon.png"/>`
 * @property {number} [backdrop] Backdrop opacity. Range: `0.0 - 1.0`. Disabled: `-1`
 * @property {SnotifyAnimate} [animation] Animation config
 * @property {string} [html] Html string witch overrides toast content
 * @property {SnotifyPosition} [position] Toasts position on screen
 */

/**
 * Buttons configuration object
 * @typedef {Object} SnotifyButton
 * @property {string} text Button text
 * @property {SnotifyButton~action} [action] Action which will be called after button click
 * @property {boolean} [bold] Should button text be bold.
 */

/**
 * This callback is displayed as part of the Requester class.
 * @callback SnotifyButton~action
 * @param {number} [id]
 * @param {string} [text]
 */

/**
 * Animations configuration object
 * @typedef {Object} SnotifyAnimate
 * @property {('fadeOutLeft' | 'fadeOutRight' | 'fadeOutUp' | 'fadeOutDown' | string)} enter In animation
 * @property {('fadeOutLeft' | 'fadeOutRight' | 'fadeOutUp' | 'fadeOutDown' | string)} exit Out animation
 * @property {number} time Animation time in ms
 */

/**
 * Options configuration object
 * @typedef {Object} SnotifyOptions
 * @property {number} maxOnScreen Max toast items on screen.
 * @property {number} maxAtPosition Max toast items at single position.
 * @property {number} maxHeight Toast maximum height in pixels.
 * @property {boolean} [newOnTop] Should new items come from top or bottom side
 * @property {SnotifyPosition} [position] Toasts position on screen
 */

/**
 * Toast model
 */
var SnotifyToast$1 =
/**
 *
 * @param {number} id
 * @param {string} title
 * @param {string} body
 * @param {SnotifyConfig} [config]
 */
function SnotifyToast(id, title, body, config) {
  classCallCheck(this, SnotifyToast);

  this.id = id;
  this.title = title;
  this.body = body;
  this.config = config;
};

var animationDefaults = generateAnimationDefaults(400);

var SnotifyService = new Vue({
  data: function data() {
    return {
      notifications: [],
      /**
       * Default toast configuration
       */
      config: {
        showProgressBar: true,
        timeout: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        bodyMaxLength: 150,
        titleMaxLength: 16,
        backdrop: -1,
        animation: animationDefaults[SnotifyPosition.rightBottom]
      },
      /**
       * Default vue-snotify options
       */
      options: {
        newOnTop: true,
        position: SnotifyPosition.rightBottom,
        maxOnScreen: 8,
        maxAtPosition: 8,
        maxHeight: 300
      }
    };
  },

  methods: {
    /**
     * returns SnotifyToast object
     * @param id {Number}
     * @return {undefined|SnotifyToast}
     */
    get: function get(id) {
      return this.notifications.find(function (toast) {
        return toast.id === id;
      });
    },
    getAll: function getAll() {
      return this.notifications.slice();
    },

    /**
     * emit changes in notifications array
     */
    emit: function emit() {
      this.$emit('notificationsChanged', this.getAll());
    },

    /**
     * Set global config
     * @param config {SnotifyConfig}
     * @param options {SnotifyOptions}
     */
    setConfig: function setConfig(config, options) {
      this.options = mergeDeep(this.options, options);
      this.config = mergeDeep(this.config, { animation: animationDefaults[this.options.position] }, config);
      this.$emit('optionsChanged', this.options);
    },

    /**
     * add SnotifyToast to notifications array
     * @param toast {SnotifyToast}
     */
    add: function add(toast) {
      toast.config.position = toast.config.position || this.options.position;
      if (this.options.newOnTop) {
        this.notifications.unshift(toast);
      } else {
        this.notifications.push(toast);
      }
      this.emit();
    },

    /**
     * If ID passed, emits toast animation remove, if ID & REMOVE passed, removes toast from notifications array
     * @param [id] {number}
     */
    remove: function remove(id) {
      if (!id) {
        return this.clear();
      } else {
        this.notifications = this.notifications.filter(function (toast) {
          return toast.id !== id;
        });
        return this.emit();
      }
    },

    /**
     * Clear notifications array
     */
    clear: function clear() {
      this.notifications = [];
      this.emit();
    },

    /**
     * Creates toast and add it to array, returns toast id
     * @param {{title, body, config}} snotify
     * @return {number}
     */
    create: function create(snotify) {
      var id = generateRandomId();
      this.add(new SnotifyToast$1(id, snotify.title, snotify.body, snotify.config || null));
      return id;
    },


    /**
     * Create toast with Success style, returns toast id;
     * @param body {string}
     * @param [title] {string}
     * @param [config] {SnotifyConfig}
     * @return {number}
     */
    success: function success(body, title, config) {
      return this.create({
        title: title,
        body: body,
        config: mergeDeep(this.config, { type: SnotifyType.SUCCESS }, config)
      });
    },

    /**
     * Create toast with Error style, returns toast id;
     * @param body {string}
     * @param [title] {string}
     * @param [config] {SnotifyConfig}
     * @return {number}
     */
    error: function error(body, title, config) {
      return this.create({
        title: title,
        body: body,
        config: mergeDeep(this.config, { type: SnotifyType.ERROR }, config)
      });
    },


    /**
     * Create toast with Info style, returns toast id;
     * @param body {string}
     * @param [title] {string}
     * @param [config] {SnotifyConfig}
     * @return {number}
     */
    info: function info(body, title, config) {
      return this.create({
        title: title,
        body: body,
        config: mergeDeep(this.config, { type: SnotifyType.INFO }, config)
      });
    },


    /**
     * Create toast with Warining style, returns toast id;
     * @param body {string}
     * @param [title] {string}
     * @param [config] {SnotifyConfig}
     * @return {number}
     */
    warning: function warning(body, title, config) {
      return this.create({
        title: title,
        body: body,
        config: mergeDeep(this.config, { type: SnotifyType.WARNING }, config)
      });
    },


    /**
     * Create toast without style, returns toast id;
     * @param body {string}
     * @param [title] {string}
     * @param [config] {SnotifyConfig}
     * @return {number}
     */
    simple: function simple(body, title, config) {
      return this.create({
        title: title,
        body: body,
        config: mergeDeep(this.config, { type: SnotifyType.SIMPLE }, config)
      });
    },


    /**
     * Create toast with Confirm style {with two buttons}, returns toast id;
     * @param body {string}
     * @param [title] {string}
     * @param [config] {SnotifyConfig}
     * @return {number}
     */
    confirm: function confirm(body, title, config) {
      var _this = this;

      var id = this.create({
        title: title,
        body: body,
        config: mergeDeep(this.config, {
          buttons: [{ text: 'Ok', action: null, bold: true }, { text: 'Cancel', action: function action() {
              return _this.remove(id);
            }, bold: false }]
        }, config, {
          type: SnotifyType.CONFIRM,
          closeOnClick: false
        })
      });
      return id;
    },


    /**
     * Create toast with Prompt style {with two buttons}, returns toast id;
     * @param body {string}
     * @param [title] {string}
     * @param [config] {SnotifyConfig}
     * @return {number}
     */
    prompt: function prompt(body, title, config) {
      var _this2 = this;

      var id = this.create({
        title: title,
        body: body,
        config: mergeDeep(this.config, {
          buttons: [{ text: 'Ok', action: null, bold: true }, { text: 'Cancel', action: function action() {
              return _this2.remove(id);
            }, bold: false }],
          placeholder: 'Enter answer here...'
        }, config, {
          timeout: 0,
          closeOnClick: false,
          type: SnotifyType.PROMPT
        })
      });
      return id;
    },


    /**
     * Creates empty toast with html string inside
     * @param html {string}
     * @param [config] {SnotifyConfig}
     * @returns {number}
     */
    html: function html(_html, config) {
      return this.create({
        title: null,
        body: null,
        config: mergeDeep(this.config, { type: SnotifyType.SIMPLE, html: _html }, config)
      });
    },


    /**
     * Creates async toast with Info style. Pass action, and resolve or reject it.
     * @param body {String}
     * @param title {String}
     * @param action {Promise<SnotifyConfig>}
     * @return {number}
     */
    async: function async(body, title, action) {
      var _this3 = this;

      var id = this.simple(body, title, {
        pauseOnHover: false,
        closeOnClick: false,
        timeout: 0,
        showProgressBar: false,
        type: SnotifyType.ASYNC
      });

      var toast = this.get(id);
      var latestToast = Object.assign({}, toast);

      var updateToast = function updateToast(type, data) {
        if (!data) {
          latestToast = mergeDeep(toast, latestToast, { config: { type: type } });
        } else {
          latestToast = mergeDeep(toast, data, { config: { type: type } });
        }
        _this3.$emit('toastChanged', latestToast);
      };
      this.$on(SnotifyAction.mounted, function (passedToast) {
        if (passedToast.id === id && action) {
          action().then(function (data) {
            updateToast(SnotifyType.SUCCESS, data);
          }).catch(function (data) {
            updateToast(SnotifyType.ERROR, data);
          });
        }
      });

      return id;
    }
  }
});

var Toast = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('transition', { attrs: { "enter-active-class": 'animated ' + _vm.toast.config.animation.enter, "leave-active-class": 'animated ' + _vm.toast.config.animation.exit }, on: { "before-enter": _vm.beforeEnter, "enter": _vm.enter, "after-enter": _vm.afterEnter, "before-leave": _vm.beforeLeave, "leave": _vm.leave } }, [_c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.opacity, expression: "opacity" }], staticClass: "snotifyToast", class: ['snotify-' + _vm.toast.config.type], style: {
        opacity: _vm.opacity,
        'max-height': _vm.maxHeight + 'px',
        '-webkit-animation-duration': _vm.toast.config.animation.time + 'ms',
        'animation-duration': _vm.toast.config.animation.time + 'ms',
        '-webkit-transition': _vm.toast.config.animation.time + 'ms',
        transition: _vm.toast.config.animation.time + 'ms'
      }, on: { "click": _vm.onClick, "mouseenter": _vm.onMouseEnter, "mouseleave": _vm.onMouseLeave } }, [_vm.toast.config.showProgressBar ? _c('div', { staticClass: "snotifyToast__progressBar" }, [_c('span', { staticClass: "snotifyToast__progressBar__percentage", style: { 'width': _vm.progress + '%' } })]) : _vm._e(), !_vm.toast.config.html ? _c('div', { staticClass: "snotifyToast__inner" }, [_vm.toast.title ? _c('div', { staticClass: "snotifyToast__title" }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.toast.title, _vm.toast.config.titleMaxLength)))]) : _vm._e(), _c('div', { staticClass: "snotifyToast__body" }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.toast.body, _vm.toast.config.bodyMaxLength)))]), _vm.toast.config.type === _vm.promptType ? _c('snotify-prompt', { attrs: { "placeholder": _vm.toast.config.placeholder }, on: { "valueChanged": _vm.promptValueChanged } }) : _vm._e(), !_vm.toast.config.icon ? _c('snotify-icon', { staticClass: "snotify-icon", attrs: { "type": _vm.toast.config.type } }) : _c('div', [_c('img', { staticClass: "snotify-icon", attrs: { "src": _vm.toast.config.icon } })])], 1) : _c('div', { staticClass: "snotifyToast__inner", domProps: { "innerHTML": _vm._s(_vm.toast.config.html) } }), _vm.toast.config.buttons ? _c('snotify-button', { attrs: { "buttons": _vm.toast.config.buttons, "value": _vm.toast.config.type === _vm.promptType ? _vm.value : null, "id": _vm.toast.id } }) : _vm._e()], 1)]);
  }, staticRenderFns: [],
  props: ['toastData'],
  data: function data() {
    return {
      toast: this.toastData,
      opacity: 0,
      interval: null,
      progress: 0,
      value: 0,
      promptType: SnotifyType.PROMPT,
      maxHeight: SnotifyService.options.maxHeight
    };
  },

  methods: {
    promptValueChanged: function promptValueChanged(value) {
      this.value = value;
      SnotifyService.$emit(SnotifyAction.onInput, this.toast, this.value);
    },

    /**
     * Initialize base toast config
     * @param [toast] {SnotifyToast}
     */
    initToast: function initToast(toast) {
      if (toast) {
        if (this.toast.config.type !== toast.config.type) {
          clearInterval(this.interval);
        }
        this.toast = toast;
      }
      if (this.toast.config.timeout > 0) {
        this.startTimeout(0);
      } else {
        this.toast.config.showProgressBar = false;
        this.toast.config.pauseOnHover = false;
      }
      this.opacity = 1;
    },

    /**
     * Start progress bar
     * @param currentProgress {Number}
     */
    startTimeout: function startTimeout(currentProgress) {
      var _this = this;

      var refreshRate = 10;
      this.progress = currentProgress;
      var step = refreshRate / this.toast.config.timeout * 100;
      this.interval = setInterval(function () {
        _this.progress += step;
        if (_this.progress >= 100) {
          _this.opacity = 0;
        }
      }, refreshRate);
    },
    beforeEnter: function beforeEnter() {
      SnotifyService.$emit(SnotifyAction.beforeShow, this.toast, this.value);
    },
    enter: function enter(el, done) {
      setTimeout(function () {
        return done();
      }, this.toast.config.animation.time);
    },
    afterEnter: function afterEnter() {
      SnotifyService.$emit(SnotifyAction.shown, this.toast, this.value);
    },
    beforeLeave: function beforeLeave() {
      clearInterval(this.interval);
      SnotifyService.$emit(SnotifyAction.beforeHide, this.toast, this.value);
    },
    leave: function leave(el, done) {
      var _this2 = this;

      setTimeout(function () {
        SnotifyService.$emit(SnotifyAction.hidden, _this2.toast, _this2.value);
        _this2.maxHeight = 0;
        setTimeout(function () {
          SnotifyService.remove(_this2.toast.id);
          done();
        }, _this2.toast.config.animation.time);
      }, this.toast.config.animation.time);
    },
    onClick: function onClick() {
      SnotifyService.$emit(SnotifyAction.onClick, this.toast, this.value);
      if (this.toast.config.closeOnClick) {
        this.opacity = 0;
      }
    },
    onMouseEnter: function onMouseEnter() {
      SnotifyService.$emit(SnotifyAction.onHoverEnter, this.toast, this.value);
      if (this.toast.config.pauseOnHover) {
        clearInterval(this.interval);
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (this.toast.config.pauseOnHover && this.type !== SnotifyType.PROMPT) {
        this.startTimeout(this.progress);
      }
      SnotifyService.$emit(SnotifyAction.onHoverLeave, this.toast, this.value);
    }
  },
  created: function created() {
    var _this3 = this;

    SnotifyService.$on('toastChanged', function (toast) {
      if (_this3.toast.id === toast.id) {
        _this3.initToast(toast);
      }
    });
    SnotifyService.$on('remove', function (id) {
      if (_this3.toast.id === id) {
        _this3.opacity = 0;
      }
    });
    this.initToast();
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      SnotifyService.$emit(SnotifyAction.mounted, this.toast, this.value);
    });
  },
  beforeDestroy: function beforeDestroy() {
    SnotifyService.$emit(SnotifyAction.beforeDestroy, this.toast, this.value);
  },
  destroyed: function destroyed() {
    SnotifyService.$emit(SnotifyAction.destroyed, this.toast, this.value);
  },

  components: {
    SnotifyIcon: SnotifyIcon,
    SnotifyPrompt: SnotifyPrompt,
    SnotifyButton: SnotifyButton
  }
};

var SnotifyToast = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', [_vm.backdrop >= 0 ? _c('div', { staticClass: "snotify-backdrop", style: { opacity: _vm.backdrop } }) : _vm._e(), _vm._l(_vm.notifications, function (position, index) {
      return _c('div', { staticClass: "snotify", class: 'snotify-' + index }, _vm._l(position.slice(_vm.blockSize_a, _vm.blockSize_b), function (toast) {
        return _c('toast', { key: toast.id, attrs: { "toastData": toast } });
      }));
    })], 2);
  }, staticRenderFns: [],
  data: function data() {
    return {
      backdrop: -1,
      positions: SnotifyPosition,
      notifications: {}
    };
  },

  methods: {
    setOptions: function setOptions(options) {
      if (options.newOnTop) {
        this.dockSize_a = -options.maxOnScreen;
        this.dockSize_b = undefined;
        this.blockSize_a = -options.maxAtPosition;
        this.blockSize_b = undefined;
      } else {
        this.dockSize_a = 0;
        this.dockSize_b = options.maxOnScreen;
        this.blockSize_a = 0;
        this.blockSize_b = options.maxAtPosition;
      }
    }
  },
  components: {
    Toast: Toast
  },
  created: function created() {
    var _this = this;

    this.setOptions(SnotifyService.options);

    SnotifyService.$on('optionsChanged', function (options) {
      _this.setOptions(options);
    });

    SnotifyService.$on('notificationsChanged', function (notifications) {
      _this.notifications = sortNotificationsByPositions(notifications.slice(_this.dockSize_a, _this.dockSize_b));
      var list = notifications.filter(function (toast) {
        return toast.config.backdrop >= 0;
      });

      if (list.length) {
        if (_this.backdrop < 0) {
          _this.backdrop = 0;
          setTimeout(function () {
            _this.backdrop = list[list.length - 1].config.backdrop;
          }, 10);
        }
      } else {
        if (_this.backdrop > 0) {
          _this.backdrop = 0;
          setTimeout(function () {
            _this.backdrop = -1;
          }, 200);
        }
      }
    });
  }
};

function install(Vue$$1) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  Vue$$1.filter('truncate', function (value) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 40;
    var trail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';

    return value.length > limit ? value.substring(0, limit) + trail : value;
  });
  Vue$$1.component('vue-snotify', SnotifyToast);
  SnotifyService.setConfig(options.config || null, options.options || null);
  Vue$$1.prototype.$snotify = SnotifyService;
}

//auto install
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install);
}

export { SnotifyType, SnotifyAction, SnotifyPosition };
export default install;
